import React from "react";
import clientConfigApi from '../config/config'


const handleResponse = (response) => {
    if (response.ok) {
        return response.json();
    } else {
        throw new Error(response.statusText);
    }
}

export const getPmsCustomerReservation = async () => {

    let room = localStorage.getItem("room");
    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    if(!room){

        return {
            status: 400,
            msg: "Please login to the app"
        }
    }

    const config = {
        "requesterUsername": "InnSpire",
        "arrivalDate": currentUserInfo[0].checkInDate.split("T")[0],
        "roomNumber": room,
        "bookingReference": currentUserInfo[0].reservationNumber
    }

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}`   
        }
    }

    try {
        let data = await clientConfigApi.post(`/tableBooking/pmsCustomerReservation`,config, headers)
        return data
    } catch (error) {
        return error
    }
}

export const getRestaurantReservationData = async () => {

    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
    };

    try {
        let data = await clientConfigApi.get(`/tableBooking/restaurant`,config)
        return data
    } catch (error) {
        return error
    }
}

export const SearchResAvailability = async (payload) => {

    const config = payload

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}`   
        }
    }

    try {
        let data = await clientConfigApi.post(`/tableBooking/restaurantAvailability`,config, headers)

        return data
    } catch (error) {
        return error
    }
}


export const GetCustomerReservation = async () => {

    const resReservationCustomerId = localStorage.getItem("resReservationCustomerId")

    const config = {
        "customerId" : resReservationCustomerId || ""
    };

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}`   
        }
    }

    try {
        let data = await clientConfigApi.post(`/tableBooking/customerReservation`,config, headers)
        return data
    } catch (error) {
        return error
    }
}


export const createRestaurantReservation = async (payload) => {
    const config = payload

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}`   
        }
    }

    try {
        let data = await clientConfigApi.post(`/tableBooking/createReservation`,config, headers)

        return data
    } catch (error) {
        return error
    }
}

export const updateRestaurantReservation = async (payload) => {
    const config = payload

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}`   
        }
    }

    try {
        let data = await clientConfigApi.put(`/tableBooking/updateReservation`,config, headers)

        return data
    } catch (error) {
        return error
    }
}

export const cancelRestaurantReservation = async (payload) => {
    const config = payload

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}`   
        }
    }

    try {
        let data = await clientConfigApi.post(`/tableBooking/cancelReservation`,config, headers)
        return data
    } catch (error) {
        return error
    }
}


export const getResResStatus = async () => {

    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
    };

    try {
        let data = await clientConfigApi.get(`tableBooking/statuses`,config)
        return data
    } catch (error) {
        return error
    }

}

export const getResAllergies = async () => {

    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
    };

    try {
        let data = await clientConfigApi.get(`tableBooking/allergies`, config)
        return data
    } catch (error) {
        return error
    }
}